export const CHANGE_MY_PROVIDER = "CHANGE_MY_PROVIDER";
export const SET_MY_PROVIDER = "SET_MY_PROVIDER";
export const FETCH_MY_PROVIDER_REQUEST = "FETCH_MY_PROVIDER_REQUEST";
export const FETCH_MY_PROVIDER_SUCCESS = "FETCH_MY_PROVIDER_SUCCESS";
export const FETCH_MY_PROVIDER_FAILURE = "FETCH_MY_PROVIDER_FAILURE";
